import { render } from "./JIMScheduling.vue?vue&type=template&id=77c88f19&scoped=true"
import script from "./JIMScheduling.vue?vue&type=script&lang=js"
export * from "./JIMScheduling.vue?vue&type=script&lang=js"

import "./JIMScheduling.vue?vue&type=style&index=0&id=77c88f19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c88f19"]])

export default __exports__